<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-offset-2 is-8">
            <div class="box">
              <h1 class="title">モード設定</h1>
              <div class="buttons">
                <button class="button is-large is-fullwidth" v-bind:class="[ mode.mode_available == 1 ? 'is-link' : '']" @click="update(1)">通常モード</button>
                <button class="button is-large is-fullwidth" v-bind:class="[ mode.mode_available == 2 ? 'is-danger' : '']" @click="update(2)">災害モード</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: function () {
    return {
      showModal: false,
      isNormal: false,
      isSaigai: false,
      isToggleActive: true,
      hasMessage: false,
      message: '',
      isError: false,
    }
  },
  computed: {
    ...mapState({
      apiStatus: state => state.item.apiStatus,
      mode: state => state.auth.mode
    }),
  },
  mounted() {
    this.$store.dispatch('item/getItems', {})
  },
  methods: {
    async update(val){
      await this.$store.dispatch('item/setMode', { mode: val})
      if(this.apiStatus){
        this.$swal({
          position: 'top-end',
          icon: 'success',
          title: 'モードを設定しました。',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },
    //   this.isToggleActive = true;
    //   this.hasMessage = false;
    //   this.message = '';
    //   this.isError = false;
    //   const data = {mode: mode};
    //     axios({
    //       method: 'POST',
    //       url:'/api/mode/edit',
    //       data: data,
    //       headers: { 'Authorization' : `Bearer ${this.$store.state.token}`}
    //     }).then(response => {
    //         this.hasMessage = true;
    //         this.message = 'モード変更が完了しました。';
    //         this.$store.commit('setMode', {
    //             mode: response.data.mode,
    //         });
    //         this.isNormal = this.$store.state.mode.mode_available == 1 ? true : false;
    //         this.isSaigai = this.$store.state.mode.mode_available == 2 ? true : false;
    //         this.isToggleActive = false;
    //     }).catch(error => {
    //       if (error.response.status === 401) {
    //         this.showModal = true
    //       } else if (error.response.status === 400){
    //         this.hasMessage = true;
    //         this.message = "エラー："+error.response.data.message;
    //         this.isError = true;
    //       } else {
    //         this.hasMessage = true;
    //         this.message = "エラー："+error.response.data.message;
    //         this.isError = true;
    //       }
    //     });
    // },
  }
}
</script>